import React, { Fragment } from "react"
import { css } from "react-emotion"

import { Icon, Button, ButtonModal } from "ui"
import AttributesForm from "../../records/components/AttributesForm"
import fieldTypes from "../utils/fieldTypes"

const DeleteFieldButton = props => (
    <ButtonModal
        dialog
        button={({ open }) => <Icon icon="trash" onClick={open} />}
        header={() => `Delete this record?`}
        footerClassName={css`
            justify-content: flex-end;
        `}
        footer={({ close, state }) => [
            <Button
                key="create"
                sideMargin="xsmall"
                color="danger"
                onClick={() => {
                    props.delete()
                    close()
                }}
            >
                Delete
            </Button>,
            <Button key="cancel" sideMargin="xsmall" onClick={close}>
                Cancel
            </Button>,
        ]}
    >
        {({ setState }) => <div />}
    </ButtonModal>
)
export default DeleteFieldButton



// WEBPACK FOOTER //
// ./src/features/studio/components/DeleteRecordButton.js